import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useProgramFeedback(programId) {
  const [programFeedback, setProgramFeedback] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.programs.programFeedback(programId))
      .then((response) => {
        setProgramFeedback(response.data.data);
      });
  }, []);

  return programFeedback;
}
